import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  BusinessDivisionBean,
  BusinessDivisionSearchCriteria,
  RestBusinessDivisionListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";

class BusinessDivisionListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
  }
  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };

  editBusinessDivision = (e, info) => {
    if (e.detail == 1) this.props.editBusinessDivision(info);
  };
  deleteBusinessDivision = (e, val, rowData) => {
    if (e.detail == 1) this.props.deleteBusinessDivision(val, rowData);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  clickGoButton = (e) => {
    if (e.detail == 1) this.props.clickGoButton();
  };
  render() {
    let businessDivision_list = this.props.businessDivision_list;

    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">Business Division</FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                name="code"
                ref={this.listFormCodeRef}
                onChange={this.props.onCheckBoxChange}
                value={this.props.businessDivisionData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                isMandatory={true}
              ></InputTextbox>
            </Col>
            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.clickGoButton(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {businessDivision_list != null ? (
              <tbody>
                {businessDivision_list.map((Info, index) => (
                  <tr key={index}>
                    <td>
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editBusinessDivision(e, Info.code)}
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.deleteBusinessDivision(e, Info.code, Info)
                        }
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {businessDivision_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class BusinessDivisionEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
  }
  componentDidMount() {
    this.setInputFocus();
  }
  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onCheckBoxChange = (e) => {
    this.props.onCheckBoxChange(e);
  };
  render() {
    let businessDivisionData = this.props.businessDivisionData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onCheckBoxChange}
              value={businessDivisionData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              ref={this.codeRef}
              placeholder="Enter BusinessDivisionCode"
              onChange={this.onCheckBoxChange}
              value={businessDivisionData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel> Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onCheckBoxChange}
              value={businessDivisionData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>

          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onCheckBoxChange}
              checked={businessDivisionData.isActive}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

class BusinessDivisionList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      businessDivision_list: [],
      pageTitle: "Business Division",
      businessDivisionData: new BusinessDivisionBean(),
      pageList: new PageListBean(),
      criteria: new BusinessDivisionSearchCriteria(),
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isBusinessDivisionListFormOpen: true,
      isBusinessDivisionEntryFormOpen: false,
      alertMessage: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowExitButton: true,
      progressLoadingText: "",
      isShowProgressBarPopup: false,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
    this.moduleCaption = "BusinessDivision";
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    let businessDivisionData = new BusinessDivisionBean();
    businessDivisionData.companyCode = this.companyCode;
    this.loadPage(1);
    this.setState({ businessDivisionData: businessDivisionData });
  }
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  cleardata = () => {
    let businessDivisionData = new BusinessDivisionBean();
    businessDivisionData.companyCode = this.companyCode;
    this.setState({ businessDivisionData: businessDivisionData });
  };
  saveBusinessDivisionResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage();
      this.cleardata();
      this.closeBusinessDivisionEntryForm();
    } else {
      this.handleresponse(response.data);
    }
  };

  saveBusinessDivision = (businessDivisionData) => {
    if (businessDivisionData.isFetched == true) {
      if (
        SecurityAccessManager.BusinessDivisionMaintenanceEdit_IsAccessible()
      ) {
        MasterService.updateBusinessDivision(
          businessDivisionData,
          this.saveBusinessDivisionResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Edit Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    } else {
      if (
        SecurityAccessManager.BusinessDivisionMaintenanceCreate_IsAccessible()
      ) {
        MasterService.createBusinessDivision(
          businessDivisionData,
          this.saveBusinessDivisionResponse,
          this.errorCallBack
        );
      } else {
        let errMsg = "Create Access Denied";
        let errList = this.state.error_list;
        errList.push(errMsg);

        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };

  editBusinessDivisionResponse = (response) => {
    if (response.data != null) {
      if (!isEmptyArray(response.data.businessDivisionBean)) {
        let businessDivisionData = new BusinessDivisionBean();
        businessDivisionData = response.data.businessDivisionBean;
        this.setState({
          businessDivisionData: businessDivisionData,
        });
        this.disable();
      }
    }
    this.openBusinessDivisionEntryForm();
  };

  editBusinessDivision = (rowdata) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = rowdata;
    if (SecurityAccessManager.BusinessDivisionMaintenanceView_IsAccessible()) {
      MasterService.readBusinessDivision(
        readrestInput,
        this.editBusinessDivisionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onCheckBoxChange = (e) => {
    let temp_businessDivisiondata = this.state.businessDivisionData;
    temp_businessDivisiondata[e.target.name] = e.target.value;

    if (e.target.name === "isActive") {
      temp_businessDivisiondata["isActive"] = e.target.value;
    }
    this.setState({
      businessDivisionData: temp_businessDivisiondata,
    });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };

  save = () => {
    let businessDivisionData = this.state.businessDivisionData;
    businessDivisionData.companyCode = this.companyCode;
    businessDivisionData.code =
      this.state.businessDivisionData.code.toUpperCase();
    this.saveBusinessDivision(businessDivisionData);
  };

  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeBusinessDivisionEntryForm();
  };

  clearError = () => {
    this.setState({ error_list: [] });
  };

  openNewBusinessDivisionEntryForm = () => {
    this.setState({
      isBusinessDivisionListFormOpen: false,
      isBusinessDivisionEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
    });
    this.hideAlertCallBack();
  };

  openBusinessDivisionEntryForm = () => {
    this.setState({
      isBusinessDivisionListFormOpen: false,
      isBusinessDivisionEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
      isShowAlert: false,
    });
    this.hideAlertCallBack();
  };

  closeBusinessDivisionEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isBusinessDivisionListFormOpen: true,
      isBusinessDivisionEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isDisableFields: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };

  loadBusinessDivisionResponse = (response) => {
    if (response.data != null && response.data.businessDivision != null) {
      let businessDivision_list = new Array();
      let pageList = this.state.pageList;
      if (!isEmptyArray(response.data.businessDivision.businessDivisions)) {
        businessDivision_list =
          response.data.businessDivision.businessDivisions;
        businessDivision_list.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });

        pageList.totalCount = response.data.businessDivision.totalCount;
        pageList.pageSize = response.data.businessDivision.pageSize;
        pageList.currentPage = response.data.businessDivision.currentPage;
      }
      this.setState({
        businessDivision_list: businessDivision_list,
        pageList: pageList,
      });
    } else {
      this.handleresponse(response.data);
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };

  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };

  loadPage = (pageNumber) => {
    let criteria = new BusinessDivisionSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;

    this.loadBusinessDivisionPage(pageInput, criteria);
  };
  loadBusinessDivisionPage = (pageList, searchCriteria) => {
    let criteria = new BusinessDivisionSearchCriteria();
    criteria = searchCriteria;

    let requestInput = new RestBusinessDivisionListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    if (SecurityAccessManager.BusinessDivisionMaintenanceView_IsAccessible()) {
      MasterService.getBusinessDivisionPageList(
        requestInput,
        this.loadBusinessDivisionResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  clickGoButton = () => {
    let businessDivisionData = this.state.businessDivisionData;
    this.editBusinessDivision(businessDivisionData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.clickGoButton();
    }, 200);
  };
  deleteBusinessDivision = (code, rowData) => {
    //
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.businessDivision_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ businessDivision_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <ProgressBar
          closeAlertModalCallBack={this.closeAlertProgressBarModalCallBack}
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isBusinessDivisionListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}

        {!this.state.isBusinessDivisionListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
          />
        )}

        {this.state.isBusinessDivisionListFormOpen && (
          <BusinessDivisionListForm
            {...this.state}
            clickGoButton={this.clickGoButton}
            editBusinessDivision={this.editBusinessDivision}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onCheckBoxChange={this.onCheckBoxChange}
            deleteService={this.deleteService}
            handleSortingChange={this.handleSortingChange}
          />
        )}

        {this.state.isBusinessDivisionEntryFormOpen && (
          <BusinessDivisionEntryForm
            {...this.state}
            businessDivisionData={this.state.businessDivisionData}
            onCheckBoxChange={this.onCheckBoxChange}
          />
        )}
      </div>
    );
  }
}

function BusinessDivisionAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="App">
        <BusinessDivisionList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default BusinessDivisionAttributeModule;
